import React from 'react';
import { SUBTITLE_LANG_LABELS } from '../constants/subtitleLanguages';
import { subtitleDebug } from '../utils/subtitleDebug';

const SubtitleControls = ({
  availableLanguages = [],
  subtitleMap = {},
  subtitlesEnabled,
  setSubtitlesEnabled,
  selectedLang,
  selectLanguage,
  showCCMenu,
  setShowCCMenu,
  ccMenuRef,
  loadingLang = null,
  className = '',
  variant = 'player',
}) => {
  const ccButtonClass =
    variant === 'inline'
      ? `text-xs font-bold min-w-[2rem] h-8 flex items-center justify-center rounded transition-colors duration-200 px-1 ${
          subtitlesEnabled
            ? 'text-white bg-white/25'
            : 'text-white/75 hover:text-white hover:bg-white/15'
        } ${loadingLang ? 'opacity-70' : ''}`
      : `text-xs font-bold px-1.5 py-0.5 rounded border transition-colors duration-200 ${
          subtitlesEnabled
            ? 'bg-white text-black border-white'
            : 'bg-transparent text-white/60 border-white/40 hover:text-white hover:border-white'
        } ${loadingLang ? 'opacity-70' : ''}`;

  return (
    <div className={`relative ${className}`} ref={ccMenuRef}>
      {showCCMenu && (
        <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 bg-gray-900/95 border border-white/20 rounded-lg overflow-hidden shadow-xl min-w-[130px] z-20">
          <button
            type="button"
            onClick={() => {
              subtitleDebug('SubtitleControls', 'CC menu — Off clicked', {
                wasEnabled: subtitlesEnabled,
                selectedLang,
              });
              setSubtitlesEnabled(false);
              setShowCCMenu(false);
            }}
            className={`w-full text-left px-3 py-2 text-xs transition-colors ${
              !subtitlesEnabled
                ? 'text-white bg-white/10'
                : 'text-gray-400 hover:bg-white/10 hover:text-white'
            }`}
          >
            Off
          </button>
          {availableLanguages.map((lang) => {
            const isSelected = subtitlesEnabled && selectedLang === lang;
            const isReady = Boolean(subtitleMap[lang]);
            const isLoading = loadingLang === lang;

            return (
              <button
                key={lang}
                type="button"
                disabled={isLoading}
                onClick={() => selectLanguage(lang)}
                className={`w-full text-left px-3 py-2 text-xs transition-colors disabled:opacity-60 ${
                  isSelected
                    ? 'text-white bg-white/10'
                    : 'text-gray-400 hover:bg-white/10 hover:text-white'
                }`}
              >
                {isLoading
                  ? `${SUBTITLE_LANG_LABELS[lang] || lang}…`
                  : `${SUBTITLE_LANG_LABELS[lang] || lang}${isReady ? '' : ' +'}`}
              </button>
            );
          })}
        </div>
      )}
      <button
        type="button"
        onClick={() => {
          subtitleDebug('SubtitleControls', 'CC button clicked', {
            togglingMenu: !showCCMenu,
            subtitlesEnabled,
            selectedLang,
            availableLangs: availableLanguages,
          });
          setShowCCMenu((prev) => !prev);
        }}
        className={ccButtonClass}
        title="Subtitles"
      >
        {loadingLang ? (
          <svg className="animate-spin" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-label="Generating captions">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.3" strokeWidth="3" />
            <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          </svg>
        ) : (
          'CC'
        )}
      </button>
    </div>
  );
};

export default SubtitleControls;
